import _ from "lodash";
import { ItemOption } from "~~/interface/ItemSetting";

export default class TableBuilder {



    combinedItems() {

    }

    computeTableItems(tables, tableInfo, settings, tableState, channelSettings) {


        _.forEach(tables, (table, tableKey) => {
            const currentChannel = tableState[tableKey]?.channel
            const findedChannel = channelSettings.find(f=>f?.channelId == currentChannel?.channelId)
            const tableServiceCharge =  findedChannel?.serviceCharge === null ? null :findedChannel?.serviceCharge

            let tableService = tableInfo[tableKey]?.sc || settings?.sc || [0, 10];
            if(tableServiceCharge!==null && tableServiceCharge!==undefined){
                tableService = [0,tableServiceCharge]
            }

          
            let tableDiscount = tableInfo[tableKey]?.dc2 || settings?.dc2 || [0, 0];
            let tableCard = tableInfo[tableKey]?.cc || settings?.cc || [0, 0];
            let tableTax = tableInfo[tableKey]?.tax || settings?.tax || [0, 0];
            //   let tableTax = 7;

            // dc2 =1
            let totalCost = 0;
            if (tableDiscount && tableDiscount[0] === 1) {
                table.items.forEach((item) => {
                    let addOn = 0;
                    let total = 0;

                    //topping
                    if (item.options2 as Array<ItemOption>) {
                        item.options2.forEach((option) => {
                            addOn += option.price * option.qty;
                        });
                    }
                    item.addOnPrice = addOn;
                    let extendedPrice = item.qty * (item.price + addOn);
                    let discountItem = 0;
                    //dicount by percentage
                    if (item.discountItem && item.discountItem[0] == 0) {
                        discountItem = - (extendedPrice * item.discountItem[1] / 100);
                    }

                    //discount by amount
                    //ของใหม่ (มี discountPerUnit) = ลดต่อชิ้น จึงคูณจำนวน เช่น ลด 25 ของ 2 ชิ้น = 50
                    //ของเก่าที่ลดไว้ก่อนเปลี่ยนกติกา = ลดครั้งเดียวทั้งบรรทัดเหมือนเดิม
                    //ยอดของบิลที่เปิดค้างอยู่จึงไม่เปลี่ยนตอน reload กลางวัน
                    if (item.discountItem && item.discountItem[0] == 1) {
                        discountItem = item.discountPerUnit
                            ? - (item.discountItem[1] * item.qty)
                            : - item.discountItem[1];
                    }
                    total = extendedPrice + discountItem;
                    let extendedPriceWithDiscount = total;


                    //service charge
                    let service = 0;
                    if (tableService && tableService[1]) {
                        service = (1 * total) * tableService[1] / 100;
                        total = total + service;
                    }
                    totalCost += total;
                });
            }


            table.items.forEach((item) => {

                let addOn = 0;
                let total = 0;

                //topping
                if (item.options2 as Array<ItemOption>) {
                    item.options2.forEach((option) => {
                        addOn += option.price * option.qty;
                    });
                }
                item.addOnPrice = addOn;
                let extendedPrice = item.qty * (item.price + addOn);
                let discountItem = 0;
                //dicount by percentage
                if (item.discountItem && item.discountItem[0] == 0) {
                    discountItem = - (extendedPrice * item.discountItem[1] / 100);
                }

                //discount by amount
                //ของใหม่ (มี discountPerUnit) = ลดต่อชิ้น จึงคูณจำนวน เช่น ลด 25 ของ 2 ชิ้น = 50
                //ของเก่าที่ลดไว้ก่อนเปลี่ยนกติกา = ลดครั้งเดียวทั้งบรรทัดเหมือนเดิม
                //ยอดของบิลที่เปิดค้างอยู่จึงไม่เปลี่ยนตอน reload กลางวัน
                if (item.discountItem && item.discountItem[0] == 1) {
                    discountItem = item.discountPerUnit
                        ? - (item.discountItem[1] * item.qty)
                        : - item.discountItem[1];
                }
                total = extendedPrice + discountItem;
                let extendedPriceWithDiscount = total;


                //service charge
                let service = 0;
                if (tableService && tableService[1]) {
                    service = (1 * total) * tableService[1] / 100;
                    total = total + service;
                }


                let discountBill = 0;
                //dicount bill by percentage
                if (tableDiscount && tableDiscount[0] === 0) {
                    discountBill = - (total * tableDiscount[1] / 100);
                }

                //discount by amount
                if (tableDiscount && tableDiscount[0] === 1) {
                    const discountAmount = tableDiscount[1]

                    // ยอดรวมทั้งโต๊ะเป็น 0 (เช่นของแถม ENT ทั้งโต๊ะ) = ไม่มีอะไรให้กระจายส่วนลด
                    // ถ้าปล่อยหาร 0 จะได้ NaN ลง item ทุกตัว แล้ว RTDB set() ของ tables
                    // ทั้งร้านจะ throw ทุกรอบจนกว่าโต๊ะนี้จะถูกปิด
                    discountBill = totalCost ? - (total / totalCost * discountAmount) : 0;
                }
                total = total + discountBill;

                //card
                let card = 0;
                if (tableCard && tableCard[1]) {
                    card = total * tableCard[1] / 100;
                }
                total = total + card;

                //tax
                let tax = 0;
                //if tax  excluded 
                if (tableTax[0] === 2) {
                    tax = total * tableTax[1] / 100;
                    total = total + tax;
                }

                // if tax included
                if (tableTax[0] === 1) {
                    tax = total * tableTax[1] / (100 + tableTax[1]);
                    tax = -1* tax;
                }


                item.subTotal = extendedPriceWithDiscount;

                item.dc1 = [item.discountItem[0], item.discountItem[1], discountItem];
                item.sc = [tableService[0], tableService[1], service];
                item.dc2 = [tableDiscount[0], tableDiscount[1], discountBill];
                item.cc = [tableCard[0], tableCard[1], card];
                item.tax = [tableTax[0], tableTax[1], tax];

                item.extendedPriceWithDiscount = extendedPriceWithDiscount;
                item.amount = total;
                item.extendedPrice = extendedPrice;
            });
        });
    }


}

// Nuxt auto-import (unimport) ลงทะเบียนชื่อคลาสนี้เป็น named export
// จึงต้อง export ชื่อออกไปด้วย ไม่งั้น build จะ resolve ไม่เจอ
// ส่วน default export ตัวเดิมยังอยู่ ผู้ที่ import แบบเดิมไม่กระทบ
export { TableBuilder };
